module.exports = __webpack_public_path__ + "img/james-hardie-logo.94ac8e26.jpg";